import React from "react";
import {
  FaDownload,
  FaPencil,
  FaTrash,
  FaHouse,
  FaEyeSlash,
  FaEye,
  FaImage,
  FaRegImage,
} from "react-icons/fa6";

if (typeof window !== "undefined") {
  document.body.style.overflow = "hidden";
  document.body.style.height = "100vh";
  document.documentElement.style.overflow = "hidden";
  document.documentElement.style.height = "100vh";
}

export default function Sidebar({
  maps,
  selectedMap,
  onSelectMap,
  onDownloadMap,
  onDownloadAll,
  onShowMassLootspot,
  onResetMarkers,
  onToggleHideUnusedMarkers,
  showUnusedMarkers,
  onToggleMapImage,
  useAlternateImages,
}) {
  // Sidebar širina uvijek fiksna
  const expandedWidth = 320;

  // Prikaži mape u fiksnom redoslijedu
  const mapOrder = ["erangel", "miramar", "taego", "rondo"];
  const sortedMaps = mapOrder
    .map((key) => maps.find((m) => m.key && m.key.toLowerCase() === key))
    .filter(Boolean);

  return (
    <div
      id="sideMenu"
      className="flex flex-col justify-between border-r border-ewave-border bg-ewave-dark"
      style={{
        width: expandedWidth,
        color: "#fff",
        padding: 24,
        position: "fixed",
        height: "100%",
        zIndex: 200,
        overflow: "hidden",
        left: 0,
        top: 0,
        backdropFilter: "blur(6px) saturate(1.2)", // usklađeno s headerom
        minWidth: expandedWidth,
        maxWidth: expandedWidth,
      }}
    >
      {/* Menu content always rendered */}
      <div className="menu-content w-full">
        {/* Maps section title */}
        <div className="relative mb-3 ml-2 text-left text-base font-semibold uppercase tracking-wider text-white opacity-90">
          <span className="inline-block border-b border-primary">MAPS</span>
        </div>
        {sortedMaps.map((map) => (
          <button
            key={map.key}
            className={`mb-2 w-full bg-ewave-darker p-4 tracking-wider hover:bg-primary ${selectedMap === map.key ? "selected" : ""}`}
            style={
              selectedMap === map.key
                ? {
                    color: "#fff",
                    fontWeight: "bold",
                    background: "var(--color-primary)",
                  }
                : {
                    color: "#fff",
                  }
            }
            onClick={() => onSelectMap(map.key)}
          >
            {map.name}
          </button>
        ))}
        {/* Divider line */}
        <div className="my-4 border-t border-ewave-border" />
        {/* Maps section title */}
        <div className="relative mb-3 ml-2 text-left text-base font-semibold uppercase tracking-wider text-white opacity-90">
          <span className="inline-block border-b border-primary">OPTIONS</span>
        </div>
        {/* Action buttons (moved from ActionSidebar) */}
        {[
          { label: "Download Current Map", onClick: onDownloadMap, icon: <FaDownload /> },
          { label: "Download All Maps", onClick: onDownloadAll, icon: <FaDownload /> },
          { label: "Bulk Lootspot Editor", onClick: onShowMassLootspot, icon: <FaPencil /> },
          { label: "Reset Markers", onClick: onResetMarkers, icon: <FaTrash /> },
          {
            label: showUnusedMarkers ? "Hide Unused Markers" : "Show Unused Markers",
            onClick: onToggleHideUnusedMarkers,
            icon: showUnusedMarkers ? <FaEyeSlash /> : <FaEye />,
          },
          {
            label: useAlternateImages ? "Show Protected Map" : "Show Clear Map",
            onClick: onToggleMapImage,
            icon: useAlternateImages ? <FaRegImage /> : <FaImage />,
          },
        ].map((btn) => (
          <button
            key={btn.label}
            className="mb-2 flex w-full items-center justify-center gap-2 bg-ewave-darker p-4 tracking-wider text-white hover:bg-primary"
            onClick={btn.onClick}
          >
            {btn.icon}
            {btn.label}
          </button>
        ))}
      </div>
      {/* Footer always rendered */}
      <div
        id="sideMenuFooter"
        className="mt-auto w-full border-t border-ewave-border bg-transparent pt-5 text-center"
      >
        <button
          key="Back To Homepage"
          className="mb-4 flex w-full items-center justify-center gap-2 bg-ewave-darker p-4 tracking-wider text-white hover:bg-primary"
          onClick={() => (window.location.href = "https://ewave.gg")}
        >
          <FaHouse />
          Back To Homepage
        </button>
        <div className="flex items-center justify-center gap-2">
          <img src="/logo192.png" alt="Logo" className="h-5 w-5" />
          <span className="text-sm font-bold tracking-wider text-white">eWave.gg</span>
        </div>
      </div>
    </div>
  );
}
